"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const AppointmentCancelContainer_1 = __importDefault(require("./components/AppointmentCancelContainer"));
const getInitialContext_1 = __importDefault(require("./stateMachine/getInitialContext"));
const main_1 = require("./stateMachine/machines/main");
const getDevLogger = () => {
    if (process.env.NODE_ENV !== 'development') {
        return () => { };
    }
    return (state) => {
        /*eslint-disable no-console */
        if (console && console.groupCollapsed && console.log && console.groupEnd) {
            console.group(`[MachineTransition]: `);
            console.log(state.value, Object.assign({}, state));
            console.groupEnd();
        }
        /*eslint-enable no-console */
    };
};
function AppointmentCancelWidget({ appointment, appointmentId, createRescheduleLink, track, searchProvidersLink, services }) {
    const machine = (0, react_1.useRef)((0, main_1.createAppointmentCancelMachine)(Object.assign(Object.assign({}, (0, getInitialContext_1.default)()), { appointment,
        appointmentId,
        services })));
    return (react_1.default.createElement(AppointmentCancelContainer_1.default, { createRescheduleLink: createRescheduleLink, logState: getDevLogger(), machine: machine.current, track: track, searchProvidersLink: searchProvidersLink }));
}
exports.default = AppointmentCancelWidget;
AppointmentCancelWidget.propTypes = {
    /**
     * An object representing the appointment we wish to cancel
     * Either this or the appointmentId string are required for this widget to initialize properly.
     * If both are provided, will default to using appointment object
     */
    appointment: (0, prop_types_1.shape)({
        appointment_ehr_id: prop_types_1.string.isRequired,
        start_datetime: prop_types_1.string.isRequired,
        patient_relationship: prop_types_1.string.isRequired,
        status: prop_types_1.string.isRequired,
        purpose_name: prop_types_1.string.isRequired,
        provider: (0, prop_types_1.shape)({
            provider_pma_id: prop_types_1.number.isRequired
        }).isRequired,
        location: {
            location_pma_id: prop_types_1.number.isRequired,
            name: prop_types_1.string.isRequired,
            address: (0, prop_types_1.shape)({
                street1: prop_types_1.string.isRequired,
                street2: prop_types_1.string.isRequired,
                city: prop_types_1.string.isRequired,
                state: prop_types_1.string.isRequired,
                zip: prop_types_1.string.isRequired,
                country: prop_types_1.string.isRequired
            }).isRequired
        }
    }),
    /**
     * The id of the appointment we are canceling
     * Either this or the appointment object are required for this widget to initialize properly.
     * If both are provided, will default to using appointment object
     */
    appointmentId: prop_types_1.number,
    /**
     * Callback that takes a providerId, patientRelationship, and patientPurpose and returns a deeplinked directbook URL for rescheduling an appointment
     * @callback createRescheduleLink
     * @param {number} providerId
     * @param {string} patientRelationship
     * @param {string} patientPurpose
     */
    createRescheduleLink: prop_types_1.func.isRequired,
    /**
     * Callback triggered for tracking
     * @callback track
     * @param {string} eventName
     * @param {object} eventData
     */
    track: prop_types_1.func.isRequired,
    /**
     * URL link for the `Search Providers` button.
     */
    searchProvidersLink: prop_types_1.string.isRequired,
    /**
     * An object containing the appointment and provider callbacks needed for the API requests.
     *
     * If the `getProvider` callback isn't included, machine will skip getting the provider and
     * won't display the sidebar or provider's name in headings.
     *
     * `getAppointment` isn't required for the case of `appointment` being passed in as a prop, but
     * this will causes errors if the widget is initialized without the `appointment` prop.
     *
     * Please check the readme for information on how to construct the callbacks.
     */
    services: (0, prop_types_1.shape)({
        cancelAppointment: prop_types_1.func.isRequired,
        getAppointment: prop_types_1.func,
        getProvider: prop_types_1.func
    }).isRequired
};
AppointmentCancelWidget.defaultProps = {
    appointment: undefined,
    appointmentId: undefined
};
//# sourceMappingURL=AppointmentCancelWidget.js.map